const SALESFORCE_ID_REGEX = /^(\w{15}|\w{18})$/;

export function isValidSalesforceId(val: string): boolean {
  return SALESFORCE_ID_REGEX.test(val);
}
